module.exports = __webpack_public_path__ + "d6d6b0e2a7e87efc8f16dca038d2c3e0.png";